import { render, staticRenderFns } from "./Foodcourt.vue?vue&type=template&id=032fa07a&scoped=true"
import script from "./Foodcourt.vue?vue&type=script&lang=ts"
export * from "./Foodcourt.vue?vue&type=script&lang=ts"
import style0 from "./Foodcourt.vue?vue&type=style&index=0&id=032fa07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fa07a",
  null
  
)

export default component.exports